export default "__VITE_ASSET__DiSCEg45__"